import { TRIAL_UPLOAD_CAP } from '@/modules/account/constants'
import StandardRestError from './Standard'

class TrialPageCapExceededError extends StandardRestError {
  static CODE = 'TRIAL_PAGE_CAP_EXCEEDED'

  constructor(_serverMessage?: string, status = 402, body = {}) {
    super(
      `Your trial keeps up to ${TRIAL_UPLOAD_CAP} pages. Remove a file, or upgrade to send more.`,
      status,
      body,
    )
  }
}

export default TrialPageCapExceededError
